import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash-es';

@Pipe({
  name: 'getUserName',
})
export class GetUserNamePipe implements PipeTransform {
  transform(element: any): string {
    return get(element, ['name'], '');
  }
}
